import React from 'react';
import { CommentAlertWrapper } from './CommentAlert.style';

export const CommentAlert: React.FC<{ message: string }> = ({ message }) => (
  <CommentAlertWrapper>{message}</CommentAlertWrapper>
);
